'use client';

import { useContext } from 'react';
import { CommentContext } from './Context';

export const useOpenComment = () => {
	const context = useContext(CommentContext);
	if (context === undefined) {
		throw new Error('useOpenComment must be used within a CommentProvider');
	}
	return context;
};
